import Vue from "vue";
import App from "./App.vue";
import i18n from "./i18n";

import {setWhitelabelConfig} from "./whitelabel";

import {ModalPlugin, ToastPlugin, TooltipPlugin, AlertPlugin, DropdownPlugin} from "bootstrap-vue";
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

import "@/styles/custom-bootstrap.scss";
import "@/styles/base.scss";
import "@/styles/sidemenu.scss";

// import AppStore from './store';
import {bootstrapSingleSPA} from "./spa/bootstrap-singlespa.js";

import {checkLogin} from "@/login-status";
import {EventBus} from "./event-bus.js";
// Vue.directive('b-tooltip', VBTooltip)
Vue.use(ModalPlugin);
Vue.use(ToastPlugin);
Vue.use(TooltipPlugin);
Vue.use(AlertPlugin);
Vue.use(DropdownPlugin);
// Vue.use(ProgressPlugin);
setWhitelabelConfig();

Vue.config.productionTip = false;

EventBus.$once("LSM:SystemConfigFetched", () => {
	checkLogin(true) && bootstrapSingleSPA();
});

EventBus.$on("USER_LOGOFF", () => {
	setWhitelabelConfig();
});

new Vue({
	i18n,
	// store: AppStore,
	render: h => h(App)
}).$mount("#app");
